import { render } from "./DInput.vue?vue&type=template&id=04496164"
import script from "./DInput.vue?vue&type=script&lang=js"
export * from "./DInput.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__